import m from 'moment'
import * as React from 'react'
//import * as _ from 'lodash'

import Persistance from "../Persistence";
import { Calendar, Caret, Checkmark } from "../../Components/Icons"

export interface Props {
    date?: string
    endDate?: string
    cb: (date: string) => void
    inline?: boolean
    month?: boolean
}

export interface State {
    date: string
    month: string
    set_date: string
    picker: boolean
    showDatePicker: boolean
}

Persistance.setValues()

export class DatePicker extends React.Component<Props, any> {
    private wrapperRef = React.createRef<HTMLInputElement>();


    public constructor(props: Props) {
        super(props)

        let date = this.props.date ?? m().format()

        this.state = {
            date,
            set_date: date,
            month: m(date).format('MMM YYYY'),
            showDatePickeefr: false
        }

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event: any) {
        if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
            if (this.state.showDatePicker) {
                this.setState({ showDatePicker: false })
            }
        }
    }

    public forwardMonth = () => {
        let month = m(`01 ${this.state.month}`).add('1', 'month').format('MMM YYYY')
        this.setState({ month })
    }

    public backMonth = () => {
        let month = m(`01 ${this.state.month}`).subtract('1', 'month').format('MMM YYYY')
        this.setState({ month })
    }

    public setDate = (date: string) => {
        this.setState({ set_date: m(date).format('YYYY-MM-DD'), month: m(date).format('MMM YYYY'), picker: false, showDatePicker: false })
        this.props.cb(date)
    }

    public incSetDate(add: boolean, span: string) {
        let newDate
        if (add) {
            newDate = m(this.state.set_date).add({ [span]: 1 }).format()
        } else {
            newDate = m(this.state.set_date).subtract({ [span]: 1 }).format()
        }
        this.setState({ set_date: newDate })
    }

    public makeSelectors = () => {
        return (
            <div className='w-content max-w-[400px] p-2'>
                            <div className='w-52 grid grid-rows gap-4'>
                <div className='flex flex-none flex-row items-center'>
                    <div className='flex-none align-middle'>
                        <div className='-rotate-90 hover:cursor-pointer' onClick={async () => await this.incSetDate(false, 'month')}><Caret size='x-small' className='fill-slate-100' /></div>
                    </div>
                    <div
                        onClick={() => this.setState({ picker: true })}
                        className='w-full text-center  hover:cursor-pointer text-white font-medium text-lg py-1 grow'>
                        {m(this.state.set_date).format('MMM')}
                    </div>
                    <div className='flex-none align-middle'>
                        <div className='rotate-90 hover:cursor-pointer' onClick={async () => await this.incSetDate(true, 'month')}><Caret size='x-small' className='fill-slate-100' /></div>
                    </div>
                </div>
                {!this.props.month && <div className='flex flex-none flex-row items-center'>
                    <div className='flex-none align-middle'>
                        <div className='-rotate-90 hover:cursor-pointer' onClick={async () => await this.incSetDate(false, 'day')}><Caret size='small' className='fill-slate-100' /></div>
                    </div>
                    <div
                        onClick={() => this.setState({ picker: true })}
                        className='w-full text-center  hover:cursor-pointer text-white font-semibold text-3xl py-1 grow'>
                        {m(this.state.set_date).format('DD')}
                    </div>
                    <div className='flex-none align-middle'>
                        <div className='rotate-90 hover:cursor-pointer' onClick={async () => await this.incSetDate(true, 'day')}><Caret size='small' className='fill-slate-100' /></div>
                    </div>
                </div> }
                <div className='flex flex-none flex-row items-center'>
                    <div className='flex-none align-middle'>
                        <div className='-rotate-90 hover:cursor-pointer' onClick={async () => await this.incSetDate(false, 'year')}><Caret size='x-small' className='fill-slate-100' /></div>
                    </div>
                    <div
                        onClick={() => this.setState({ picker: true })}
                        className='w-full text-center  hover:cursor-pointer text-white font-medium text-lg py-1 grow'>
                        {m(this.state.set_date).format('YYYY')}
                    </div>
                    <div className='flex-none align-middle'>
                        <div className='rotate-90 hover:cursor-pointer' onClick={async () => await this.incSetDate(true, 'year')}><Caret size='x-small' className='fill-slate-100' /></div>
                    </div>
                </div>
                <div className='text-white w-content justify-self-center rounded-full bg-slate-100 hover:cursor-pointer text-center' onClick={() => this.setDate(this.state.set_date)}><Checkmark className='fill-slate-900' size='large' /></div>
            </div>
            </div>
        )
    }

    public makeMonth = () => {
        let day = m(`01 ${this.state.month}`).startOf('week')

        let display = []

        for (let i = 1; i <= 35; i++) {
            //let month = m(s.date).format('DD') === '01' || this.props.schedule.indexOf(s) === 0 ? '' : 'hidden'
            let numberColor = m(day).isSame(m(), 'day') ? 'text-primary-200' : 'text-gray-200';
            //numberColor = m(s.date).isSame(this.state.focus, 'day') ? 'text-white' : numberColor
            let background = 'bg-transparent '
            background = m(day).isSame(this.state.set_date) ? 'bg-primary-800 rounded-full' : background
            let today = day.format('YYYY-MM-DD')

            display.push(
                <div id={`cal_box_${day.format()}`}
                    onClick={() => this.setDate(today)}
                    className={`aspect-square ${background} p-1 relative hover:cursor-pointer justify-items-center`}>
                    <div className={`${numberColor} h-auto w-auto text-center text-xs text-right -z-60`}>
                        {m(day).format('DD')}
                    </div>
                </div>)

            day = m(day).add('1', 'day')
        }

        let rightCaret = (<div className='rotate-90 hover:cursor-pointer' onClick={async () => await this.forwardMonth()}><Caret size='x-small' className='fill-slate-100' /></div>)
        let leftCaret = (<div className='-rotate-90 hover:cursor-pointer' onClick={async () => await this.backMonth()}><Caret size='x-small' className='fill-slate-100' /></div>)


        return (
            <div className='w-content max-w-[400px] p-2'>
                <div className='w-full flex flex-col gap-1'>
                <div className='flex flex-none flex-row items-center'>
                    <div className='flex-none align-middle'>
                        {leftCaret}
                    </div>
                    <div
                        onClick={() => this.setState({ picker: true })}
                        className='w-full text-center underline underline-offset-2 hover:cursor-pointer text-white font-medium text-sm py-1 grow'>
                        {this.state.month}
                    </div>
                    <div className='flex-none align-middle'>
                        {rightCaret}
                    </div>
                </div>
                <div className='w-full grid grid-cols-7 gap-2 mb-1 text-white text-xs text-center border-b border-gray-400'>
                    <div>SU</div><div>MO</div><div>TU</div><div>WE</div><div>TH</div><div>FR</div><div>SA</div>
                </div>
                <div className='w-full grid grid-cols-7 gap-2'>
                    {display}
                </div>

            </div>
            </div>
        )
    }

    public makeDropDown = () => {
        return (
            <div ref={this.wrapperRef} className='w-full'>
                <div
                    onClick={() => this.setState({ showDatePicker: !this.state.showDatePicker })}
                    className='flex flex-cols gap-3 items-center border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'>
                    <div className='flex-none'><Calendar className='fill-slate-500' size='small' /></div>
                    <div className='grow'>
                        {m(this.state.set_date).format('MMM DD YYYY')}
                    </div>
                </div>
                {this.state.showDatePicker &&
                    <div className='absolute z-10 left-0 mt-1 origin-top-left dark:bg-gray-800 rounded-md'>
                        {this.state.picker ? this.makeSelectors() : this.makeMonth()}
                    </div>
                }
            </div>

        )
    }

    public render(): React.ReactNode {

        let display
        if (this.props.inline) {
            display = this.state.picker ? this.makeSelectors() : this.makeMonth()
        } else if (this.props.month){
            display = this.makeSelectors()    
        } else {
            display = this.makeDropDown()
        }

        return (<div>
            {display}
        </div>)
    }

}

export default DatePicker